import React from "react";
import { CircleX } from "lucide-react";
import { SCROLL_OFFSET, ARTICLE_COLUMN, H2, BODY_SM } from "./sections";

const MISTAKES = [
  {
    lead: "Rambling without a clear ask.",
    body: " A longer prompt is only useful if it is still building toward a specific request. Close with a clear, direct instruction, not just background.",
  },
  {
    lead: "Forgetting to specify format.",
    body: " Without a stated format, most AI tools default to a full paragraph response, even when a list or table would serve you better.",
  },
  {
    lead: "Not reviewing before sending.",
    body: " Always glance at the dictated prompt before hitting send, especially for anything with numbers, names, or technical terms.",
  },
  {
    lead: "Treating it like a voice assistant command.",
    body: " Voice prompting AI works best as a short spoken explanation, not a one-line command like you would give a smart speaker.",
  },
];

const CommonMistakesSection = () => {
  return (
    <section
      id="common-mistakes"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <h2 className={H2}>Common Mistakes To Avoid</h2>

      <ul className="mt-[30.05px] flex flex-col gap-[17.17px]">
        {MISTAKES.map(({ lead, body }) => (
          <li key={lead} className="flex items-start gap-[12.88px]">
            <span className="mt-[3px] flex shrink-0 text-[#F0554B]">
              <CircleX className="h-[16px] w-[16px]" strokeWidth={2} />
            </span>

            <p className={BODY_SM}>
              <strong className="font-bold text-[#0A0D16]">{lead}</strong>
              {body}
            </p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default CommonMistakesSection;
